import { render, staticRenderFns } from "./ReviewsBlock.vue?vue&type=template&id=edb5cdd0&"
import script from "./ReviewsBlock.ts?vue&type=script&lang=ts&"
export * from "./ReviewsBlock.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports